( function( global, $ ) {

    if($('[name="cat[]"]:checked,[name="col[]"]:checked').length) {
        $('[gr-form-reset]').removeClass('is-hidden');
    }

    /*
    $('.gr-form--filters').on('click', 'input[type=checkbox]', function() {
        if ($(this).closest('form').find('input[type=checkbox]:checked').length) {
            $('[gr-form-reset]').removeClass('is-hidden');
        } else {
            $('[gr-form-reset]').addClass('is-hidden');
        }

        // $(this).closest('.gr-form__field').find('input').prop('checked', $(this).prop('checked'));

        $(this).parentsUntil('.form--filters', '.gr-form__field').each(function() {
            var parent = $(this).parent('.gr-form__field').children('input'),
                siblings = $(this).parent('.gr-form__field').children('.gr-form__field').children('input');

            updateParentBasedOnSiblings(parent, siblings);
        });
    });

    $('[gr-form-reset]').on('click', function(e) {
        e.preventDefault();
        $(this).closest('form').find('input[type=checkbox]:checked').each(function(){
            $(this).prop('checked', false);
        });
    });

    function updateParentBasedOnSiblings(parent, siblings) {
        var numberOfInputs = siblings.length,
            numberOfInputsChecked = siblings.filter(function() {
                return $(this).prop('checked') || $(this).prop('indeterminate');
            }).length;

        parent.prop('indeterminate', numberOfInputsChecked > 0 && numberOfInputsChecked < numberOfInputs);
        parent.prop('checked', numberOfInputsChecked === numberOfInputs);
    }*/


    $('.searchSubmit').click(function(){
        var form = $(this).closest('form');
        if(form.find('[name="s"]').val().length) {
            form.submit();
        }
    });

    function findFormFromDataAttr(element) {
        var formID = element.data('form-id');

        if (!formID) {
            console.warn('formID not found');
            return;
        }

        var form = $('#' + formID);

        if (!form[0]) {
            console.warn('No form found with this ID:', formID);
            return;
        }

        return form;
    }

    $('[gr-form-submit]').click(function(e) {
        e.preventDefault();

        var form = findFormFromDataAttr($(this));

        form.submit();
    });

    $('[gr-form-reset]').on('click', function(e) {
        e.preventDefault();

        var form = findFormFromDataAttr($(this));

        form.find('input[type=checkbox]:checked').each(function(){
            $(this).prop('checked', false);
        });

        form.submit();
    });

    //scrolltop apres click sur reset
    $('[data-reset-filters]').on('click', function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#filters").offset().top
        }, 300);
    });

}( window.groots, jQuery ));
